<script>
    import {snippetFlip} from "./gp-context-items";
    import {getGPTransFunc} from "./gp-translations.js";

    let trans = getGPTransFunc("gp-snippetpickerfilters");

</script>


<div class="btn-group dropup GPSearchButtons">
    <div class="btn-group btn-group-xs " role="group">
        <a href="#" tabindex="0" class="btn btn-default" on:click={() =>{$snippetFlip = !$snippetFlip}}><i class="fas fa-arrows-alt-h" style="font-size: 16px; padding: 8px;" title={trans("Flip")}></i></a>
    </div>

</div>
